<template>
    <div>
        <div class="login-box">
            <div class="card" style="margin-top: 38%;">
                <div class="body">
                    <img :src="require('@/assets/logo.png')" style="margin: 0 auto; display: block; z-index: 2; margin-top: -82px; width: 30%; padding-top: 10px; margin-bottom: 15px;">
                    <form id="sign_in" method="POST" v-on:submit.prevent="login" ref="form">
                        <div class="logo">
                            <a href="#" style="color: #333; font-size: 28px;">Admin<b>DAPENBI</b></a>

                        </div>
                        <div class="input-group">
                            <span class="input-group-addon">
                                <i class="material-icons">person</i>
                            </span>
                            <formline ref="username" type="text" name="username" v-model="user.username" placeholder="Username" required autofocus></formline>
                        </div>
                        <div class="input-group">
                        <span class="input-group-addon">
                            <i class="material-icons">lock</i>
                        </span>
                            <form-line type="password" name="password" v-model="user.password" placeholder="Password" required></form-line>
                        </div>
                        <div style="margin: 0 auto; display: block; text-align: center;">
                            <button v-bind:disabled="isLoading" class="btn btn-primary waves-effect" v-waves.button style="color: #fff;">
                                <span v-if="!isLoading">MASUK</span>
                                <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                            </button>
                        </div>
                        <div class="row m-t-15 m-b--20">
                            <div style="text-align: center; padding-bottom: 5%;">
                                <a href="#" @click="$router.push('lupa-password')">Lupa Password?</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div style="text-align: center; color: #fff;">
            <p>copyright 2018 | Dana Pensiun Indonesia</p>
        </div>
        <div style="text-align: center; color: #fff;">
            <p>Designed by <a href="http://birutekno.com/" style="color: #fff;">Birutekno Inc</a></p>
        </div>
    </div>
</template>

<script>
  import FormLine from '../components/FormLine.vue'
  import api from '@/helper/api'

  export default {
    components: {FormLine},
    name: 'Login',
    data: function () {
      return {
        user: {
          username: '',
          password: '',
          rememberMe: false,
          isWeb: true
        },
        isLoading: false
      }
    },
    beforeMount () {
      const log = localStorage.getItem('_token')
      const akses = localStorage.getItem('akses')

      if (log && akses) this.$router.replace('/main/dashboard')
    },
    methods: {
      login () {
        this.isLoading = true
        api.post('/login', this.user).then(result => {
          if (result.data._token != null) {
            var token = result.data._token
            if (!result.data.isAdmin) {
              this.$swal('Perhatian', 'Username atau password salah', 'error')
            } else {
              localStorage.setItem('_token', token)
              localStorage.setItem('username', result.data.username)
              localStorage.setItem('namaLengkap', result.data.namaLengkap)
              localStorage.setItem('akses', result.data.akses)
              this.$router.replace('/main/dashboard')
              location.reload()
            }
          } else {
            this.$swal('Perhatian', result.data.message, 'error')
          }
          this.isLoading = false
        }).catch(e => {
          this.$swal('Perhatian', e.response.data.message, 'error')
          this.isLoading = false
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Login.vue?6911f14a